import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const FALLBACK_IMAGES = ["/products/detail.png", "/products/back.png", "/products/collar.png", "/products/front.png"];

export default function SocialStrip() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.getSettings().then(setSettings).catch(() => {});
  }, []);

  const handle = settings?.ig_handle || "dejonrichh";
  const images = settings?.social_images?.length ? settings.social_images : FALLBACK_IMAGES;

  return (
    <section className="border-t border-wire" data-testid="social-strip">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-16 sm:py-20">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="font-mono text-[10px] tracking-[0.35em] text-neutral-500">FOLLOW THE OUTFIT</p>
              <h2 className="mt-3 font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white">
                @{handle}
              </h2>
            </div>
            <a href={`https://instagram.com/${handle}`} target="_blank" rel="noopener noreferrer" data-testid="social-strip-follow"
              className="flex items-center gap-2 border border-wire px-6 py-3 font-mono text-[10px] tracking-[0.3em] text-neutral-300 transition-colors hover:border-white hover:text-white">
              <Instagram size={13} strokeWidth={1.5} /> FOLLOW
            </a>
          </div>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 gap-px border border-wire bg-wire sm:grid-cols-4">
          {images.slice(0, 4).map((src, i) => (
            <a key={src + i} href={`https://instagram.com/${handle}`} target="_blank" rel="noopener noreferrer"
              data-testid={`social-tile-${i}`} className="group relative block overflow-hidden bg-obsidian">
              <img src={src} alt={`Dejon Richh on Instagram — ${i + 1}`}
                className="aspect-square w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100" />
              <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <Instagram size={22} strokeWidth={1.5} className="text-white" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
